import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { MetaService } from '../meta.service';
@Component({
  selector: 'app-peekay-case-study',
  templateUrl: './peekay-case-study.component.html',
  styleUrls: ['./peekay-case-study.component.scss']
})
export class PeekayCaseStudyComponent implements OnInit {
  title = 'End-to-End Healthcare Management Solutions | Qaptive';
  constructor(
    private titleService: Title, 
    private metaService: MetaService,
    private meta: Meta
  ) { }

  ngOnInit(): void {
    this.titleService.setTitle(this.title);
    this.meta.updateTag(
      { name: 'description', content: "Our precise solution for the healthcare industry ensures quality and cost-effective outcomes by providing appointment scheduling, e-prescribing, medical billing, etc" }
    );
    this.metaService.createCanonicalURL();
  }

}
